module.exports = __webpack_public_path__ + "img/font.a6f55506.png";